/* eslint-disable @next/next/no-img-element */
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

export default function HeaderLogo({ logoUrl, logoWidth, logoWidthMobile }: HeaderElementDataType) {
  const query = useSearchParams();
  const themeId = query.get('theme_id') || '';
  const token = query.get('token') || '';

  if (!logoUrl) return <div className='text-lg font-bold'>LOGO</div>;

  return (
    <Link
      href={`/${token ? `?theme_id=${themeId}&token=${token}` : ''}`}
      className='flex items-center'
    >
      <img src={logoUrl} alt='Logo' className='header-width' />
      <style jsx>{`
        .header-width {
          width: ${logoWidth ?? 100}px;
        }

        @media (max-width: 768px) {
          .header-width {
            width: ${logoWidthMobile ?? 65}px;
          }
        }
      `}</style>
    </Link>
  );
}
